import React from 'react'
import Link from '../../components/common/Link'

const PageSubTab = ({ subTabs, onClickSubTab }) => {
  return (
    <div className="lnb_dep_wrap">
      <div className="container">
        <ul>
          {subTabs.map((tab, i) => (
            <li key={`${i}`} className={'dep4' + (tab.isActive ? ' active' : '')}>
              <Link
                to={tab.link}
                onClick={e => {
                  e.preventDefault()
                  onClickSubTab && onClickSubTab(i)
                }}
              >
                {tab.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default PageSubTab
